import type { EntityRegistryEntry } from './types';

import { setConfig } from './entries/setConfig';
import { workflowConfig } from './entries/workflowConfig';
import { workflowActivityConfig } from './entries/workflowActivityConfig';
import { policyRuleConfig } from './entries/policyRuleConfig';
import { emailTemplateConfig } from './entries/emailTemplateConfig';
import { contentConfig } from './entries/contentConfig';
import { groupConfig } from './entries/groupConfig';
import { requestApprovalTypeConfig } from './entries/requestApprovalTypeConfig';
import { requestApprovalConfig } from './entries/requestApprovalConfig';
import { spooledEmailConfig } from './entries/spooledEmailConfig';
import { fileConfig } from './entries/fileConfig';
import { apiUserConfig } from './entries/apiUserConfig';
import { journalEntryConfig } from './entries/journalEntryConfig';
import { setTransitionConfig } from './entries/setTransitionConfig';
import { schemaEntityConfig } from './entries/schemaEntityConfig';
import { schemaAttributeConfig } from './entries/schemaAttributeConfig';
import { employeeConfig } from './entries/employeeConfig';
import { contractorConfig } from './entries/contractorConfig';
import { photoConfig } from './entries/photoConfig';
import { modificationErrorConfig } from './entries/modificationErrorConfig';
import { appRegistrationConfig } from './entries/appRegistrationConfig';
import { credentialConfig } from './entries/credentialConfig';

const ENTITY_REGISTRY = new Map<string, EntityRegistryEntry>();

function register(key: string, entry: EntityRegistryEntry) {
    ENTITY_REGISTRY.set(key.toLowerCase(), entry);
}

register('set', setConfig);
register('workflow', workflowConfig);
register('workflowactivity', workflowActivityConfig);
register('policyrule', policyRuleConfig);
register('emailtemplate', emailTemplateConfig);
register('content', contentConfig);
register('group', groupConfig);
register('requestapprovaltype', requestApprovalTypeConfig);
register('requestapproval', requestApprovalConfig);
register('spooledemail', spooledEmailConfig);
register('file', fileConfig);
register('apiuser', apiUserConfig);
register('journalentry', journalEntryConfig);
register('settransition', setTransitionConfig);
register('schemaentity', schemaEntityConfig);
register('schemaattribute', schemaAttributeConfig);
register('employee', employeeConfig);
register('contractor', contractorConfig);
register('photo', photoConfig);
register('modificationerror', modificationErrorConfig);
register('appregistration', appRegistrationConfig);
register('credential', credentialConfig);

export function getEntityConfig(entityType: string): EntityRegistryEntry | undefined {
    if (!entityType) return undefined;
    return ENTITY_REGISTRY.get(entityType.toLowerCase());
}

export { ENTITY_REGISTRY };
export type { EntityRegistryEntry } from './types';
export * from './types';
